// @ts-nocheck
/* eslint-disable */
import { makeEvent } from "~/lib/signals";
import Scene from "~/scene";

/**
 * @class Mapy.Popup.Window
 * Hlavni objekt vytvoreneho popup okna.
 * @signal popup-close pri zavreni okna
 */
Mapy.Popup.Window = class {
	/**
	 * Vytvoření popup okna.
	 *
	 * @param  {Object} [opt]
	 * @param  {Number} [opt.maxWidth] max. sirka v [px]
	 * @param  {Boolean} [opt.draggable] da se okno presouvat?
	 * @param  {String} [opt.className] pridavne css jmeno
	 * @param  {Mapy.Popup.Window.POSITIONS} [opt.position] Def. pozice okna na obrazovce
	 * @param  {Number} [opt.positionPadding] u vseho kde neni na ose x,y center - moznost pridat padding
	 * @param  {String} [opt.id] vlastni ID, default random
	 */
	constructor(opt) {
		this._opt = {
			maxWidth: null,
			draggable: true,
			className: "",
			position: Mapy.Popup.Window.POSITIONS.CENTER_CENTER,
			positionPadding: 0,
			id: ""
		};

		for (var key in opt) {
			this._opt[key] = opt[key];
		}

		this._isDraggedOut = false;
		this._savedWidth = 0;
		this._savedHeight = 0;
		this._savedX = 0;
		this._savedY = 0;
		this._id = this._opt.id || new Date().getTime().toString(16);
		this._dom = {};
		this._screen = {
			width: 0,
			height: 0
		};

		this._setScreenSize();

		this._dom.root = this._createRoot();
		this._dom.root.setAttribute("data-id", this._id);

		if (this._opt.draggable) {
			this._dom.root.classList.add(Mapy.Popup.Window.CONST.DRAGGABLE_CLASS_NAME);
			this._dom.root.addEventListener("mousedown", this, false);
		}

		// content
		this._dom.content = document.createElement("div");
		this._dom.content.classList.add("content");

		this._dom.root.appendChild(this._dom.content);

		// close btn
		this._dom.closeBtn = document.createElement("button");
		this._dom.closeBtn.setAttribute("type", "button");
		this._dom.closeBtn.classList.add("close-btn", "notranslate");
		this._dom.closeBtn.innerHTML = "c";
		this._dom.closeBtn.addEventListener("click", this, false);

		this._dom.root.appendChild(this._dom.closeBtn);
		this._popupComp = Mapy.getComponent("popup");
		this._popupComp.registerPopup(this);

		document.getElementById("mapycz").appendChild(this._dom.root);

		this.setPosition();
	}

	/**
	 * Zavreni popupu.
	 */
	close() {
		if (this._dom.root) {
			this._dom.root.remove();
			this._popupComp.unregisterPopup(this);

			this._isDraggedOut = false;
			this._dom.root = null;
			makeEvent("popup-close", this);
		}
	}

	/**
	 * Ziskani ID okna.
	 *
	 * @return {Number}
	 */
	getId() {
		return this._id;
	}

	/**
	 * Nachazi se uvnitr okna zadany element?
	 *
	 * @param  {Element}  el
	 * @return {Boolean}
	 */
	isElInside(el) {
		if (el) {
			while (el && el.parentNode && el.tagName != "BODY" && el.tagName != "HTML") {
				el = el.parentNode;

				if (el.getAttribute("data-id") == this._id) {
					return true;
				}
			}
		}

		return false;
	}

	/**
	 * Ma okno focus?
	 * @return {Boolean}
	 */
	hasFocus() {
		var el = document.activeElement;

		return this.isElInside(el);
	}

	/**
	 * Nastaveni pozice popupu
	 * @param {Object} [pos] volitelne, jinak se bere z toho configu pri vytvoreni
	 */
	setPosition(pos) {
		this._setScreenSize();
		if (!this._isDraggedOut) {
			this._setPosition(pos);
		}
		else {
			this._setPositionAfterDragged();
		}
	}

	/**
	 * Ziskani root el.
	 *
	 * @return {Element}
	 */
	getContentEl() {
		return this._dom.content;
	}

	handleEvent(e) {
		var type = e && e.type ? e.type : "";

		switch (type) {
			case "mousedown":
				if (e.target.classList.contains(Mapy.Popup.Window.CONST.CLASS_NAME)) {
					e.preventDefault();
					e.stopPropagation();

					this._savedX = parseInt(this._dom.root.style.left, 10) - e.clientX;
					this._savedY = parseInt(this._dom.root.style.top, 10) - e.clientY;

					this._dom.moveCover = this._createMoveCover();

					document.getElementById("mapycz").appendChild(this._dom.moveCover);

					this._dom.moveCover.addEventListener("mousemove", this, false);
					this._dom.moveCover.addEventListener("mouseup", this, false);
				}
				break;

			case "mousemove":
				var x = e.clientX;
				var y = e.clientY;

				var left = x + this._savedX;
				var top = y + this._savedY;

				this._isDraggedOut = true;

				this._setRootPosition(left, top);
				break;

			case "mouseup":
				this._dom.moveCover.removeEventListener("mousemove", this, false);
				this._dom.moveCover.removeEventListener("mouseup", this, false);

				this._dom.moveCover.remove();

				this._dom.moveCover = null;
				break;

			case "click":
				this.close();
				break;
		}
	}

	_calculatePosition(eposition) {
		var width = this._dom.root.offsetWidth;
		var height = this._dom.root.offsetHeight;

		// default center - center
		var left = Math.floor((this._screen.width - width) / 2);
		var top = Math.floor((this._screen.height - height) / 2);
		var epos = Mapy.Popup.Window.POSITIONS;

		switch (eposition) {
			case epos.TOP_LEFT:
				left = 0 + this._opt.positionPadding;
				top = 0 + this._opt.positionPadding;
				break;

			case epos.TOP_CENTER:
				left = Math.floor((this._screen.width - width) / 2);
				top = 0 + this._opt.positionPadding;
				break;

			case epos.TOP_RIGHT:
				left = this._screen.width - width - this._opt.positionPadding;
				top = 0 + this._opt.positionPadding;
				break;

			case epos.CENTER_LEFT:
				left = 0 + this._opt.positionPadding;
				top = Math.floor((this._screen.height - height) / 2);
				break;

			case epos.CENTER_RIGHT:
				left = this._screen.width - width - this._opt.positionPadding;
				top = Math.floor((this._screen.height - height) / 2);
				break;

			case epos.BOTTOM_LEFT:
				left = 0 + this._opt.positionPadding;
				top = this._screen.height - height - this._opt.positionPadding;
				break;

			case epos.BOTTOM_CENTER:
				left = Math.floor((this._screen.width - width) / 2);
				top = this._screen.height - height - this._opt.positionPadding;
				break;

			case epos.BOTTOM_RIGHT:
				left = this._screen.width - width - this._opt.positionPadding;
				top = this._screen.height - height - this._opt.positionPadding;
				break;

			case epos.MAP_CENTER:
				var size = Scene.getSize();

				left = Math.floor((size.x - width) / 2);
				top = Math.floor((size.y - height) / 2);
				break;
		}

		return {
			left: left,
			top: top
		};
	}

	_setRootPosition(x, y) {
		var left = x || 0;
		var top = y || 0;
		var width = this._dom.root.offsetWidth;
		var height = this._dom.root.offsetHeight;

		// uprava x, y
		if (left < 0) {
			left = 0;
		}
		else if (left + width > this._screen.width) {
			left = this._screen.width - width;
		}

		if (top < 0) {
			top = 0;
		}
		else if (top + height > this._screen.height) {
			top = this._screen.height - height;
		}

		// pri prekroceni vysky
		if (!this._savedHeight && height > this._screen.height) {
			this._dom.root.classList.add(Mapy.Popup.Window.CONST.OVERFLOW_Y_CLASS_NAME);
			this._savedHeight = height;
		}
		else if (this._savedHeight && this._savedHeight < this._screen.height) {
			this._savedHeight = 0;

			// cajk
			this._dom.root.classList.remove(Mapy.Popup.Window.CONST.OVERFLOW_Y_CLASS_NAME);
		}

		// uprava sirky
		if (!this._savedWidth && width > this._screen.width) {
			if ("getComputedStyle" in window) {
				var style = window.getComputedStyle(this._dom.root);
				width = parseInt(style.width, 10);
			}

			this._savedWidth = this._opt.maxWidth ? Math.min(width, this._opt.maxWidth) : width;
			this._dom.root.style.width = (this._opt.maxWidth ? Math.min(this._screen.width, this._opt.maxWidth) : this._screen.width) + "px";

			// responzivni mod
			this._dom.root.classList.add(Mapy.Popup.Window.CONST.RESPONSIVE_CLASS_NAME);
		}
		else if (this._savedWidth) {
			if (this._savedWidth < this._screen.width) {
				// responzivni mod - opoustime
				this._dom.root.classList.remove(Mapy.Popup.Window.CONST.RESPONSIVE_CLASS_NAME);

				this._dom.root.style.width = this._savedWidth + "px";
				this._savedWidth = 0;
			}
			else {
				// mensi - stale v responzivnim modu
				this._dom.root.style.width = this._screen.width + "px";
			}

			var cp = this._calculatePosition();
			left = cp.left >= 0 ? cp.left : 0;
			top = cp.top >= 0 ? cp.top : 0;
		}

		// pozice
		this._dom.root.style.left = left + "px";
		this._dom.root.style.top = top + "px";
	}

	// [pos] z enum pozic; volitelna, jinak se bere z konfigu
	_setPosition(pos) {
		var left = 0;
		var top = 0;

		if (!pos) {
			pos = this._opt.position;
		}

		if (typeof pos === "number") {
			var cp = this._calculatePosition(pos);

			left = cp.left;
			top = cp.top;
		}
		else if (typeof pos === "object") {
			left = pos.left || 0;
			top = pos.top || 0;
		}

		this._setRootPosition(left, top)
	}

	_setPositionAfterDragged() {
		// u odtahnuteho okna zjistime, jestli jde videt cele
		var width = this._dom.root.offsetWidth;
		var height = this._dom.root.offsetHeight;
		var l = this._dom.root.offsetLeft;
		var t = this._dom.root.offsetTop;

		if ((width + l > this._screen.width) || (height + t > this._screen.height)) {
			// stred
			var cp = this._calculatePosition();
			// defaultni
			var def = this._calculatePosition(this._opt.position);

			// nastavime
			if (cp.left != def.left && cp.top != def.top) {
				this._setRootPosition(def.left, def.top);
			}
			else {
				this._setRootPosition(cp.left, cp.top);
			}

			this._isDraggedOut = false;
		}
	}

	_createRoot() {
		var el = document.createElement("div");
		el.classList.add(Mapy.Popup.Window.CONST.CLASS_NAME);

		if (this._opt.className) {
			el.classList.add(this._opt.className);
		}

		el.setAttribute("touch-action", "none");

		return el;
	}

	_createMoveCover() {
		var el = document.createElement("div");
		el.classList.add(Mapy.Popup.Window.CONST.MOVE_COVER_CLASS_NAME);

		return el;
	}

	_setScreenSize() {
		this._screen.width = Math.min(window.innerWidth, document.getElementById("mapycz").offsetWidth);
		this._screen.height = window.innerHeight;
	}
};

// staticky enum - kotvici body
Mapy.Popup.Window.POSITIONS = {
	TOP_LEFT: 0,
	TOP_CENTER: 1,
	TOP_RIGHT: 2,
	CENTER_LEFT: 3,
	CENTER_CENTER: 4,
	CENTER_RIGHT: 5,
	BOTTOM_LEFT: 6,
	BOTTOM_CENTER: 7,
	BOTTOM_RIGHT: 8,
	MAP_CENTER: 9,
	MAP_ABOVE_SHARE: 10
};

// konstanty
Mapy.Popup.Window.CONST = {
	CLASS_NAME: "popup-window",
	MOVE_COVER_CLASS_NAME: "popup-move-cover",
	DRAGGABLE_CLASS_NAME: "draggable",
	RESPONSIVE_CLASS_NAME: "responsive-mode", // responzivni mod pri mensi sirce popupu nez obrazovky
	OVERFLOW_Y_CLASS_NAME: "overflow-y" // obsah popupu je mensi jako vyska obrazovky
};
